import amplitude from "amplitude-js";

export class AmplitudeClient {
  /**
   * @type {amplitude.AmplitudeClient}
   */
  _client = null;
  _userId = "";

  constructor(apiKey) {
    let userId = this._userId;
    const storedId =
      localStorage.getItem("amplitudeUserId") ||
      localStorage.getItem("user_id");

    if (storedId) {
      userId = storedId;
    } else {
      localStorage.setItem("amplitudeUserId", this._userId);
      localStorage.setItem("user_id", this._userId);
    }
    this._client = amplitude.getInstance("amplitude");
    this._client.init(apiKey, userId, {
      includeUtm: true,
      includeReferrer: true,
    });

    this._init();
  }

  _init() {
    if (!this._client) {
      throw new Error("Amplitude client is not initialized");
    }
    const identify = new amplitude.Identify();
    this._client.identify(identify);
    console.log("log> init identify", identify);
  }

  /**
   * Logs an event
   * @param {string} event Event name
   * @param {Record<string, unknown>} data Properties to store for the event
   */
  log(event, data) {
    if (!this._client) {
      throw new Error("Amplitude client is not initialized");
    }
    this._client.logEvent(event, data);
  }

  /**
   * Adds user identification info to the client
   * @param {object} user User object from where identity info will be added
   */
  async identify(user) {
    if (!this._client) {
      throw new Error("Amplitude client is not initialized");
    }
    if (this._userId === user._id) {
      console.log("User already identified.");
      return;
    }
    this._client.setUserId(user._id);
    this._userId = user.id;
    localStorage.setItem("amplitudeUserId", this._userId);
    localStorage.setItem("userId", this._userId);

    const identify = new amplitude.Identify();

    identify.set("lastViewedDate", new Date().toISOString());
    identify.set("status", "loggedIn");
    identify.set("isLoggedIn", true);

    this._client.identify(identify);
    console.log("log> identify", identify);
  }

  /**
   * Sets a user property to a value
   * @param {string} key Identity property key
   * @param {string} value Identity value
   */
  setIdentityParam(key, value) {
    const identify = new amplitude.Identify();
    identify.set(key, value);
    this._client.identify(identify);
  }

  /**
   * Adds a number to a user property
   * @param {string} key Identity property key
   * @param {number} value Identity value
   */
  addIdentityParam(key, value) {
    const identify = new amplitude.Identify();
    identify.add(key, value);
    this._client.identify(identify);
  }
}
